import { useRecoilState } from 'recoil';
import * as Atom from '../recoil/index';
import { useBridge } from './useBridge';
import useNav from './useNav';
import useCounterInTime from './useCounterInTime';

const useFooter = () => {
  const br: any = useBridge();
  const { navigate } = useNav();
  const { count } = useCounterInTime(4000, 7);
  const [useMtgLoan, setUseMtgLoan] = useRecoilState(Atom.useMtgLoan);

  const navigateOvertake = () => {
    br?.openExternalBrowser({ url: 'https://overtake.kr/company/' });
  };
  const navigateOvertakePrivacy = () => {
    br?.openExternalBrowser({ url: 'https://overtake.kr/policy/privacy/' });
  };
  const navigateOnlineLoanCorp = () => {
    br?.openExternalBrowser({
      url: 'https://www.fss.or.kr/fss/bbs/B0000315/list.do?menuNo=200755',
    });
  };
  const navigateTestPage = () => {
    const { avaliable } = count();
    // 전체 반영하기 전에 일부 사용자만 확인할 수 있도록 수정
    // if (useMtgLoan && process.env.REACT_APP_ENV !== 'production') {
    //   if (!avaliable) {
    //     navigate('/test');
    //   }
    // } else {
    //   if (!avaliable) {
    //     setUseMtgLoan(true);
    //     navigate('/nextMain');
    //   }
    // }
    if (process.env.REACT_APP_ENV !== 'production') {
      if (!avaliable) {
        navigate('/test');
      }
    }
  };

  return {
    navigateOvertake,
    navigateOvertakePrivacy,
    navigateOnlineLoanCorp,
    navigateTestPage,
  };
};

export default useFooter;
